import { Paper } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { UseFormReturn, useFieldArray, useFormContext } from 'react-hook-form';

import { Modality } from '@/constants/TrainingConstants';

import SubtitleText from '../atoms/SubtitleText';
import { TrainingCell } from './TrainingCell';

interface Props {
	methods: UseFormReturn<any, any, any>;
	setOnlineMaxDaysInput: (value: boolean) => void;
	setInPersonMaxDaysInput: (valuie: boolean) => void;
}

const AllTrainings = ({
	methods,
	setOnlineMaxDaysInput,
	setInPersonMaxDaysInput,
}: Props) => {
	const { control } = useFormContext();
	const { fields, append, remove } = useFieldArray({
		control,
		name: `trainings`,
	});
	const addTraining = () => {
		append({
			id: null,
			locations: [],
			modalities: [],
			trainingType: null,
			name: null,
			totalWorkload: null,
			inPersonWorkload: null,
			onlineWorkload: null,
		});
	};

	const updateDueInputs = useCallback(() => {
		const trainings = methods.getValues('trainings')
			? methods.getValues('trainings')
			: [];
		const modalities = trainings.flatMap(
			(el: { modalities: Modality[] }) => el.modalities,
		);

		// Se contém treinamento semipresencial, habilita ambos os campos
		const onlineInputEnabled =
			modalities.includes(Modality.Online) ||
			modalities.includes(Modality.Semipresencial);
		const inPersonInputEnabled =
			modalities.includes(Modality.Presencial) ||
			modalities.includes(Modality.Semipresencial);

		setOnlineMaxDaysInput(onlineInputEnabled);
		setInPersonMaxDaysInput(inPersonInputEnabled);
		if (!onlineInputEnabled) {
			methods.resetField('onlineMaxDays', { defaultValue: '' });
		}
		if (!inPersonInputEnabled) {
			methods.resetField('inPersonMaxDays', { defaultValue: '' });
		}
	}, [methods, setOnlineMaxDaysInput, setInPersonMaxDaysInput]);

	useEffect(() => {
		updateDueInputs();
	}, [fields, updateDueInputs]);

	return (
		<Paper sx={{ background: '#edeff1', padding: 1, marginBottom: 3 }}>
			<div className="flex items-center py-2">
				<SubtitleText
					subtitle={'Treinamentos Aplicados'}
					className="text-[16px]"
				/>
			</div>
			{fields.map((el, idx) => {
				return (
					<TrainingCell
						key={el.id}
						methods={methods}
						updateDueInputs={updateDueInputs}
						idx={idx}
						remove={remove}
					/>
				);
			})}
			<button
				type="button"
				className="mt-2 text-[12px] text-primary underline "
				onClick={addTraining}
			>
				Adicionar treinamento
			</button>
		</Paper>
	);
};

export default AllTrainings;
